import {
  CreateOrderItem,
  OrderItemAmount,
  PurchaseOrderStatus,
  SalesOrderStatus,
  VolumeUnit
} from '@shipwell/corrogo-sdk';

export const volumeLabels: Record<VolumeUnit, string> = {
  [VolumeUnit.CuFt]: 'FT\u00B3',
  [VolumeUnit.CuM]: 'M\u00B3',
  [VolumeUnit.Gallon]: 'GAL',
  [VolumeUnit.Liter]: 'L'
};
export const purchaseOrderStatusLabels: Record<PurchaseOrderStatus, string> = {
  NOT_READY: 'Not Ready',
  READY: 'Ready',
  FILLED: 'Filled',
  ASSIGNED: 'Assigned',
  CANCELLED: 'Cancelled',
  DISPATCHED: 'Dispatched',
  IN_TRANSIT: 'In Transit',
  OUT_FOR_DELIVERY: 'Out for Delivery',
  DELIVERED: 'Delivered'
};
export const salesOrderStatusLabels: Record<SalesOrderStatus, string> = {
  NOT_READY: 'Not Ready',
  READY: 'Ready',
  FILLED: 'Filled',
  ASSIGNED: 'Assigned',
  CANCELLED: 'Cancelled',
  DISPATCHED: 'Dispatched',
  IN_TRANSIT: 'In Transit',
  OUT_FOR_DELIVERY: 'Out for Delivery',
  DELIVERED: 'Delivered'
};

export const orderSuccessActionTitle = 'Success!';
export const getOrderSuccessActionDetail = (verb: string) => `Your order was successfully ${verb}.`;

export const blankOrderItem: CreateOrderItem = {
  amount: {
    value: '',
    unit: '' as OrderItemAmount['unit']
  },
  shipping_requirements: {
    description: ''
  }
};

export const CORROGO_ORDERS_IMPORT_TYPE = 'PURCHASE_OR_SALES_ORDER';
